import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";

import Tutorial from "../../../../Tutorial";

import messages from "./messages";
import { IProps } from "./interfaces";

const BarsortingTutorial =({ close, title }: IProps) => (
    <Tutorial close={close} title={title} videoId={"_sR3udzIWoM"}>
        {[
            {
                title: <FormattedMessage {...messages.title1} />,
                content: <FormattedHTMLMessage {...messages.description1} />,
            },
            {
                title: <FormattedMessage {...messages.title2} />,
                content: <FormattedHTMLMessage {...messages.description2} />,
            },
            {
                title: <FormattedMessage {...messages.title3} />,
                content: <FormattedHTMLMessage {...messages.description3} />,
            },
        ]}
    </Tutorial>
);

export default BarsortingTutorial;
